import { contextualizeRESTModuleV2 } from './context-v2.js';
export function createRESTModule(descriptor, elevated = false) {
    return contextualizeRESTModuleV2(descriptor, elevated);
}
